<template>
  <div
    class="timeline-row revision-item w-100"
    :class="{
      'read-only': isReadOnly,
      'is-first': isFirst,
      'is-last': isLast,
    }"
    @click="handleClick"
  >
    <div class="timeline-row__inner d-flex ga-2 px-6 align-center">
      <div v-if="showConnector" class="timeline-indicator d-flex align-center justify-center flex-shrink-0 position-relative h-100">
        <div
          class="timeline-line position-absolute"
        />
        <div class="timeline-dot position-absolute rounded-circle" />
      </div>

      <div class="py-4 d-flex flex-column ga-2 flex-grow-1 min-w-0">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  showConnector: {
    type: Boolean,
    default: true,
  },
  isReadOnly: {
    type: Boolean,
    default: false,
  },
  isFirst: {
    type: Boolean,
    default: false,
  },
  isLast: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  if (props.isReadOnly) return;

  emit('click');
};
</script>

<style lang="less" scoped>
.timeline-row {
  cursor: pointer;

  &__inner {
    min-height: 100%;
  }

  &:not(.read-only):hover {
    background-color: @indigo-100;
  }

  &.read-only {
    cursor: default;
  }

  .timeline-indicator {
    width: 9px;
  }

  .timeline-line {
    width: 1px;
    background-color: @stroke-dark;
    height: 150px;
  }

  &.is-first .timeline-line {
    height: 100px;
    top: 50%;
  }

  &.is-last .timeline-line {
    height: 100px;
    bottom: 50%;
  }

  .timeline-dot {
    width: 10px;
    height: 10px;
    border: 1px solid @stroke-dark;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: @white;
  }
}
</style>
